import { Phone, ArrowRight } from "lucide-react";
import { requestOffer } from "./scroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { COMPANY, FAQS } from "./data";
import { SectionHead, Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" aria-labelledby="faq-title" className="relative bg-paper py-24 text-ink sm:py-32 lg:py-40" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <SectionHead id="faq-title" tone="light" eyebrow="Ehrliche Antworten" title={<>Ihre Bedenken.<br />Unsere Antworten.</>}
            intro="Die Fragen, die uns jeder Kunde stellt – klar beantwortet. Ihre ist nicht dabei? Ein Anruf genügt." />
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-col gap-3 sm:max-w-md">
              <a href={COMPANY.phoneHref} className="btn-primary btn-mega justify-center" data-testid="faq-phone-link"><Phone size={20} /> Anrufen: {COMPANY.phoneDisplay}</a>
              <button type="button" onClick={() => requestOffer("Dachcheck & Beratung")} className="btn-dark btn-mega justify-center" data-testid="faq-offer-btn">Gratis-Dachcheck sichern <ArrowRight size={18} className="btn-arrow" /></button>
            </div>
          </Reveal>
        </div>
      </div>
      <Reveal className="lg:col-span-7" delay={0.1}>
        <Accordion type="single" collapsible className="border-t border-ink/15" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-ink/15">
              <AccordionTrigger className="gap-6 py-7 text-left font-display text-xl font-bold uppercase leading-tight text-ink hover:no-underline sm:text-2xl [&>svg]:h-6 [&>svg]:w-6 [&>svg]:text-terra-ink" data-testid={`faq-trigger-${i}`}>
                <span className="flex gap-5"><span className="text-base text-terra-ink">0{i + 1}</span>{f.q}</span>
              </AccordionTrigger>
              <AccordionContent className="pb-7 pl-10 pr-4 text-base leading-relaxed text-slate-700">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
